// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1Z21W","primary":"Button_primary__3fMax","disabled":"Button_disabled__1YW8P"};